import { r as registerInstance, h, F as Fragment, g as getElement } from './index-16dc7dde.js';
import { o as omit_1 } from './omit-0983201d.js';
import './request.constants-deb285e0.js';
import { s as store, p as pesCatalogPageTypes } from './pes-router-store-1a105b49.js';
import './product-card-6bb8cb81.js';
import './store-9d26336f.js';
import './utils-15ad90ec.js';
import { P as PesRoute } from './pes-route-63457678.js';
import { g as getIsCustomAddToCartEnabled, a as getCustomAddToCartSettings, b as getIsProductsInCustomCart, c as getIsCustomAddToFavoritesEnabled, d as getCustomAddToFavoritesSettings, n as navigateWithRouter } from './utils-60b2d521.js';
import { L as LINK_TYPES } from './constants-ad5439d0.js';
import { E as ECarouselRelation } from './types-8e186e36.js';
import { g as getFilteredBreadcrumbs } from './utils-400179ea.js';
import './toString-da636857.js';
import './isObject-33fa1780.js';
import './_commonjsHelpers-ba3f0406.js';
import './isTypedArray-dfccd669.js';
import './isSymbol-45bfef0c.js';
import './_Uint8Array-2e849395.js';
import './identity-6651b537.js';
import './_baseTimes-db8626dd.js';
import './_isIndex-af307327.js';
import './_assignValue-8e900715.js';
import './_getAllKeysIn-8178afb2.js';
import './_flatRest-49cdf089.js';
import './_baseFlatten-2670ede5.js';
import './index-634d378a.js';
import './pick-bfea8c03.js';
import './_basePickBy-9e484e47.js';
import './hasIn-6ce0da41.js';
import './index-136476ff.js';
import './lookups-705fb53e.js';
import './analytics-765d4daf.js';
import './send-33ade633.js';
import './utils-913bdf8a.js';
import './pes-product-link-b5153381.js';
import './utils-e67addce.js';
import './isEmpty-b60327cb.js';
import './utils-2361a8f1.js';
import './tslib.es6-2af8cb53.js';
import './toNumber-5000b45d.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const pesAppPdpCss = ":host{display:block}@media screen and (max-width: 719px){.pes-app-pdp__section:not(.pes-app-pdp__section--breadcrumbs)+.pes-app-pdp__section{margin-top:20px}}@media screen and (min-width: 980px){.pes-app-pdp__section:not(.pes-app-pdp__section--breadcrumbs)+.pes-app-pdp__section{margin-top:8px}}@media screen and (min-width: 980px){.pes-app-pdp__section--breadcrumbs{background-color:#ffffff;padding-bottom:8px}}";

let PesAppPdp = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
    store.set('productCTAs', this.productCtas);
    store.set('showCustomPrice', this.showCustomPrice);
    store.set('customPrice', this.customPrice);
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return {
      breadcrumbs: getFilteredBreadcrumbs((_a = this.allData) === null || _a === void 0 ? void 0 : _a.breadcrumbs),
    };
  }
  get productMainAreaCTAData() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const mainAreaCTAData = Object.assign(Object.assign({}, (_a = this.allData) === null || _a === void 0 ? void 0 : _a.base.ctaArea), { buttons: {} });
    const defaultButtons = ((_b = this.allData) === null || _b === void 0 ? void 0 : _b.base.ctaArea.buttons) || {};
    if (getIsCustomAddToCartEnabled()) {
      let defaultLabel = (_c = getCustomAddToCartSettings().labels) === null || _c === void 0 ? void 0 : _c.addLabel;
      if (getIsProductsInCustomCart([this.productId])) {
        defaultLabel = (_d = getCustomAddToCartSettings().labels) === null || _d === void 0 ? void 0 : _d.removeLabel;
      }
      mainAreaCTAData.buttons["ADD_TO_CART_BUTTON"] = {
        labels: {
          defaultLabel: defaultLabel || ((_e = this.allData.cta) === null || _e === void 0 ? void 0 : _e.addToCartLabel),
        },
      };
    }
    if (this.showBuyOnline
      && ((_g = (_f = defaultButtons["BUY_ONLINE_BUTTON_REGULAR"]) === null || _f === void 0 ? void 0 : _f.labels) === null || _g === void 0 ? void 0 : _g.defaultLabel)) {
      mainAreaCTAData.buttons["BUY_ONLINE_BUTTON_REGULAR"] = {
        labels: {
          defaultLabel: (_j = (_h = defaultButtons["BUY_ONLINE_BUTTON_REGULAR"]) === null || _h === void 0 ? void 0 : _h.labels) === null || _j === void 0 ? void 0 : _j.defaultLabel,
        },
      };
    }
    if ("DOWNLOAD_BUTTON" in defaultButtons) {
      mainAreaCTAData.buttons["DOWNLOAD_BUTTON"] = defaultButtons["DOWNLOAD_BUTTON"];
    }
    if ("NOTIFY_ME_BUTTON" in defaultButtons) {
      mainAreaCTAData.buttons["NOTIFY_ME_BUTTON"] = defaultButtons["NOTIFY_ME_BUTTON"];
    }
    return mainAreaCTAData;
  }
  get customLinks() {
    var _a, _b, _c, _d, _e, _f;
    const links = {};
    if (getIsCustomAddToFavoritesEnabled()) {
      links[LINK_TYPES.ADD_TO_MY_PRODUCTS] = {
        labels: {
          defaultLabel: ((_a = getCustomAddToFavoritesSettings().labels) === null || _a === void 0 ? void 0 : _a.addLabel)
            || ((_b = this.allData.cta) === null || _b === void 0 ? void 0 : _b.addToFavoritesLabel),
          removeLabel: ((_c = getCustomAddToFavoritesSettings().labels) === null || _c === void 0 ? void 0 : _c.removeLabel)
            || ((_d = getCustomAddToFavoritesSettings().labels) === null || _d === void 0 ? void 0 : _d.addLabel)
            || ((_e = this.allData.cta) === null || _e === void 0 ? void 0 : _e.removeFromFavoritesLabel),
        },
      };
    }
    if (this.showCompare) {
      links[LINK_TYPES.COMPARE] = {
        labels: { defaultLabel: (_f = this.allData) === null || _f === void 0 ? void 0 : _f.base.links.COMPARE.labels.defaultLabel },
      };
    }
    return links;
  }
  get customOfflineStores() {
    var _a;
    return omit_1((_a = this.allData) === null || _a === void 0 ? void 0 : _a.base.offlineStores, 'findResellerLink');
  }
  render() {
    var _a;
    if (this.status.isLoading.all) {
      return h("pdp-skeleton", null);
    }
    if (!this.allData)
      return;
    if (typeof this.status.error.all === 'object') {
      const route = new PesRoute({ page: pesCatalogPageTypes.ALL_PRODUCTS });
      navigateWithRouter(route, this.el);
    }
    return (h(Fragment, null, this.showBreadcrumbs && (h("pes-breadcrumbs", Object.assign({}, this.customBreadcrumbs, { hideOnMobile: true, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs" }))), h("pes-product-main", Object.assign({}, (_a = this.allData) === null || _a === void 0 ? void 0 : _a.base, { productId: this.productId, productCR: this.productId, localeCode: this.localeCode, ctaArea: this.productMainAreaCTAData, links: this.customLinks, offlineStores: this.customOfflineStores, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, countryCode: this.countryCode, class: "pes-app-pdp__section", isPBS: true }), h("slot", { name: "discounted-price", slot: "discounted-price" })), h("pes-asset-bar-and-related-products", Object.assign({}, this.allData.assetBarRelatedProducts, { localeCode: this.localeCode, class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.Compatiblesoftware }, this.allData.compatibleSoftware, { class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.crossSellLife }, this.allData.crossSellLife, { class: "pes-app-pdp__section" })), h("pes-description-and-specifications", Object.assign({}, this.allData.specifications, { class: "pes-app-pdp__section" })), h("pes-sustainability", Object.assign({}, this.allData.sustainability, { class: "pes-app-pdp__section" })), h("pes-epds", { epds: this.allData.epds, class: "pes-app-pdp__section" }), this.ddc && (h("pes-product-documents-and-software", Object.assign({}, this.ddc, { class: "pes-app-pdp__section" }))), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.upsell }, this.allData.upsell, { class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({ relationType: ECarouselRelation.crosssell }, this.allData.crosssell, { class: "pes-app-pdp__section" })), this.showFaq && h("pes-faq", Object.assign({}, this.allData.faq, { class: "pes-app-pdp__section" })), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { class: "pes-app-pdp__section" }))));
  }
  get el() { return getElement(this); }
};
PesAppPdp.style = pesAppPdpCss;

export { PesAppPdp as pes_app_pdp };
